import { Box, Typography } from '@mui/material';

import { FSPL_ABOUT_1, FSPL_ABOUT_2 } from '../../constants/strings';

import PageLayout from '../../components/shared/page-layout/page-layout.component';
import PortfolioCarousel from '../../components/shared/portfolio-carousel/portfolio-carousel.component';

import { useAboutPageStyles } from './about-page.styles';

const About = () => {
  const classes = useAboutPageStyles();

  return (
    <PageLayout hideHeading>
      <Box className={classes.apWrapper}>
        <Box
          display='flex'
          flexDirection='column'
          justifyContent='space-between'
          width='50%'
          sx={{
            '@media (max-width: 1024px)': {
              width: '100%',
            },
          }}
        >
          <Typography className={classes.ourMission}>our misson</Typography>
          <Typography className={classes.misson}>
            To engage
            <br /> & entertain
          </Typography>
        </Box>

        <Box
          width='50%'
          sx={{
            '@media (max-width: 1024px)': {
              width: '100%',
            },
          }}
        >
          <Typography className={classes.aboutCompany}>
            {FSPL_ABOUT_1}
            <br />
            <br />
            {FSPL_ABOUT_2}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ padding: '140px 0' }}>
        <PortfolioCarousel />
      </Box>
    </PageLayout>
  );
};

export default About;
